import { render, staticRenderFns } from "./tvs_invite.vue?vue&type=template&id=5c072c18&scoped=true"
import script from "./tvs_invite.vue?vue&type=script&lang=js"
export * from "./tvs_invite.vue?vue&type=script&lang=js"
import style0 from "./tvs_invite.vue?vue&type=style&index=0&id=5c072c18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c072c18",
  null
  
)

export default component.exports